module.exports = __webpack_public_path__ + "img/key_features--safety.d4535e24.png";